import { cleanObject } from '@shared/utils';
import createRequestFailure from '@/redux/requests/lib/createRequestFailure.js';

const normalizeRequestFailure = ({ responseShape, fallbackMessage, message = undefined, data = undefined } = {}) => {
  const rawBody = responseShape?.rawBody;
  const payload = responseShape?.data || {};
  const payloadData = payload?.data || {};

  if (typeof rawBody === 'string' && rawBody.length > 0) {
    return {
      ...responseShape,
      data: createRequestFailure({
        message: 'API returned non-JSON response',
        status: responseShape?.status || null,
        data: {
          text: rawBody
        }
      })
    };
  }

  if (payload?.success !== false) {
    return responseShape;
  }

  return {
    ...responseShape,
    data: createRequestFailure({
      code: payload?.code,
      message: String(message || payload?.message || payload?.error || fallbackMessage || 'Request failed').trim() || 'Request failed',
      status: payload?.status || responseShape?.status || null,
      detail: payload?.detail,
      data:
        data === undefined
          ? cleanObject(
              {
                ...(payloadData && typeof payloadData === 'object' && !Array.isArray(payloadData) ? payloadData : {}),
                text: payload?.text,
                body: payloadData?.body
              },
              { strict: true }
            )
          : data
    })
  };
};

export default normalizeRequestFailure;
